import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import BackButton from '../components/BackButton';
import StackGraph from '../components/StackGraph';
import StackPhaseNav from '../components/StackPhaseNav';
import { phases } from '../data/stack';
import './Stack.css';

const Stack = () => {
  const [activePhase, setActivePhase] = useState(null);

  const handlePhaseEnter = useCallback((id) => setActivePhase(id), []);
  const handlePhaseLeave = useCallback(() => setActivePhase(null), []);

  return (
    <>
    <BackButton />
    <header className="stack-floating-header">
      <h1>Stack</h1>
      <p className="page-intro">
        The tools behind my workflow, from pixel to production.
      </p>
      <StackPhaseNav
        phases={phases}
        activePhase={activePhase}
        onPhaseEnter={handlePhaseEnter}
        onPhaseLeave={handlePhaseLeave}
      />
    </header>
    <div className="stack-page">
      <StackGraph activePhase={activePhase} onBackgroundTap={handlePhaseLeave} />
    </div>
    {/* Fixed, not in-flow — rendered as a sibling of .stack-page (like
        BackButton/.stack-floating-header above) rather than nested inside
        it, since .stack-page is a `main > div` and the global `fadeUp`
        animation's lingering transform would otherwise turn it into the
        containing block for a `position: fixed` descendant instead of the
        real viewport. */}
    <Link to="/side-projects" className="stack-cta">
      See what I've built with it in Side Projects
      <span className="arrow">›</span>
    </Link>
    </>
  );
};

export default Stack;
